import { apiService } from './api';
import { PaginationParams } from '../types/common';

export interface LookupTableItem {
  id: string;
  category: string;
  key: string;
  value: string;
  status: 'ACTIVE' | 'INACTIVE';
  createdAt: string;
  updatedAt: string;
}

export interface LookupTablesResponse {
  lookupTables: LookupTableItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

class LookupTableService {
  async getLookupTables(params?: PaginationParams & { category?: string; status?: 'ACTIVE' | 'INACTIVE' }): Promise<LookupTablesResponse> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    if (params?.category) queryParams.append('category', params.category);
    if (params?.status) queryParams.append('status', params.status);

    return apiService.get<LookupTablesResponse>(`/lookup-tables?${queryParams.toString()}`);
  }

  async create(data: { category: string; key: string; value: string; description?: string; sortOrder?: number; status?: 'ACTIVE' | 'INACTIVE'; }): Promise<{ message: string; lookup: LookupTableItem }> {
    return apiService.post('/lookup-tables', data);
  }

  async update(id: string, data: { category?: string; key?: string; value?: string; description?: string; sortOrder?: number; status?: 'ACTIVE' | 'INACTIVE'; }): Promise<{ message: string; lookup: LookupTableItem }> {
    return apiService.put(`/lookup-tables/${id}`, data);
  }

  async delete(id: string): Promise<{ message: string }> {
    return apiService.delete(`/lookup-tables/${id}`);
  }
  async bulkUpdateStatus(ids: string[], status: 'ACTIVE' | 'INACTIVE'): Promise<{ success: boolean; message: string; count: number }> {
    return apiService.post<{ success: boolean; message: string; count: number }>(`/lookup-tables/bulk-status`, { ids, status });
  }


  async export(params?: { search?: string; category?: string; status?: 'ACTIVE' | 'INACTIVE'; ids?: string[] }): Promise<Blob> {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.category) queryParams.append('category', params.category);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.ids && params.ids.length) queryParams.append('ids', params.ids.join(','));
    const baseURL = process.env.REACT_APP_API_URL || '/api';
    const response = await fetch(`${baseURL}/lookup-tables/export?${queryParams.toString()}`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    if (!response.ok) throw new Error('Export failed');
    return response.blob();
  }
}

export const lookupTableService = new LookupTableService();

